import React from 'react';
import PropTypes from 'prop-types';
import styles from './SearchFootnote.module.less';

function SearchFootnote(props) {
  const { children, title, description } = props;

  return (
    <>
      {(description || children) && title && (
        <h3 className={styles.title}>{title}</h3>
      )}
      {description && (
        <div
          className={styles.description}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
      {children}
    </>
  );
}

SearchFootnote.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
};

export default SearchFootnote;
